import Vue from 'vue'
import Router from 'vue-router'

//import { createRouter,createWebHistory } from 'vue-router'
import Layout from '../layout'
import LayoutMain from '../layout_main/index.vue'
import LayoutMainLd from '../layout_main/landingpage.vue'

import subRouter from './subRoute'
Vue.use(Router)
//const subRouter = '/plus/'

export const constantRoutes = [
    {
      path: subRouter,
      component: Layout,
      children: [{
        path: subRouter,
        component: () => import('@/view/home/index')
      },
      {
        path: subRouter + 'register-result-success.html',
        component: () => import('@/view/home/accept'),
        name: 'Result',
        meta: {money: 0}
      }
    ]
    },
    {
      path: subRouter + 'register-result-ekyc.html',
      component: Layout,
      children: [{
        path: subRouter + 'register-result-ekyc.html',
        component: () => import('@/view/profile/index'),
        name: 'Reject'
      }]
    },
    {
      path: subRouter + 'info-ekyc.html',
      component: Layout,
      children: [{
        path: subRouter + 'info-ekyc.html',
        component: () => import('@/view/profile/no_partner'),
        name: '2Reject'
      }]
    },
    {
      path: subRouter + 'dieu-khoan-chinh-sach',
      component: Layout,
      children: [{
        path: subRouter + 'dieu-khoan-chinh-sach',
        component: () => import('@/view/policy/index'),
        name: 'Policy'
      }]
    },
    {
      path: subRouter + 'blog',
      component: Layout,
      children: [{
        path: subRouter + 'blog',
        component: () => import('@/view/blog/index')
      }]
    },
    {
      path: subRouter + 'blog/chi-tiet/:id/:slug',
      component: Layout,
      children: [{
        path: subRouter + 'blog/chi-tiet/:id/:slug',
        component: () => import('@/view/blog/detail')
      }]
    },
]

export const vMainRoutes = [
  {
    path: '/',
    component: LayoutMain,
    children: [{
        path: '/',
        component: () => import('@/view_main/home/indexNew')
      },
      {
        path: '/register-result-success.html',
        component: () => import('@/view_main/home/accept'),
        name: 'VResult',
      }
    ],
  },
  {
    path: '/l/:short_link',
    component: LayoutMain,
    children: [{
        path: '/l/:short_link',
        component: () => import('@/view_main/home/shortLink')
      },
    ],
  },
  {
    path: '/register-result-ekyc.html',
    component: LayoutMain,
    children: [{
      path: '/register-result-ekyc.html',
      component: () => import('@/view_main/profile/index'),
      name: 'VReject'
    }]
  },
  {
    path: '/update-result-ekyc.html',
    component: LayoutMain,
    children: [{
      path: '/update-result-ekyc.html',
      component: () => import('@/view_main/success/update-info'),
      name: 'VUpdateReject'
    }]
  },
  {
    path: '/update-step-end.html',
    component: LayoutMain,
    children: [{
      path: '/update-step-end.html',
      component: () => import('@/view_main/success/end-step'),
      name: 'VUpdateStepEnd'
    }]
  },
  {
    path: '/step-thanks.html',
    component: LayoutMain,
    children: [{
      path: '/step-thanks.html',
      component: () => import('@/view_main/success/thanks'),
      name: 'VStepThanks'
    }]
  },
  {
    path: '/info-ekyc.html',
    component: LayoutMain,
    children: [{
      path: '/info-ekyc.html',
      component: () => import('@/view_main/profile/no_partner'),
      name: 'VInfo'
    }]
  },
  {
    path: '/thanks.html',
    component: LayoutMain,
    children: [{
      path: '/thanks.html',
      component: () => import('@/view_main/profile/thanks'),
      name: 'Thanks'
    }]
  },
  {
    path: '/dieu-khoan-chinh-sach',
    component: LayoutMain,
    children: [{
      path: '/dieu-khoan-chinh-sach',
      component: () => import('@/view_main/policy/index'),
      name: 'VPolicy'
    }]
  },
  {
    path: '/blog',
    component: LayoutMain,
    children: [{
      path: '/blog',
      component: () => import('@/view_main/blog/index')
    }]
  },
  {
    //path: '/blog/chi-tiet/:id/:slug',
    path: '/:slug-:id.html',
    component: LayoutMain,
    children: [{
      path: '/:slug-:id.html',
      component: () => import('@/view_main/blog/detail')
    }]
  },
  {
    //path: '/blog/chi-tiet/:id/:slug',
    path: '/vay-nhanh-fastmoney',
    component: LayoutMainLd,
    children: [{
      path: '/vay-nhanh-fastmoney',
      component: () => import('@/view_main/fastmoney_ld/index')
    }]
  },

  {
    path: '/404',
    component: LayoutMainLd,
    hidden: true,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    children: [
        {
            path: '/404',
            component: () => import('@/view_main/error-page/404'),
            name: 'Page404',
        }
    ]
  },
  { path: '/*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
    mode: 'history', // require service support
    base: '/',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes.concat(vMainRoutes),
  })
  
const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router